module.exports = {
	"countries": [
		{
			"name": "Austria",
			"slug": "austria",
			"cities": [
				{
					"name": "Bregenz",
					"slug": "bregenz",
					"stores": [
						{
							"name": "Vero Moda romerstrasse",
							"adres": "Römerstrasse 2\n6900 Bregenz\nAustria"
						}
					]
				},
				{
					"name": "Burs",
					"slug": "burs",
					"stores": [
						{
							"name": "Vero Moda almteilweg",
							"adres": "Almteilweg 1\nZimbapark\n6706 Bürs\nAustria"
						}
					]
				},
				{
					"name": "Dornbirn",
					"slug": "dornbirn",
					"stores": [
						{
							"name": "Vero Moda markplatz",
							"adres": "Markplatz 10\n6850 Dornbirn\nAustria"
						}
					]
				},
				{
					"name": "Feldkirch",
					"slug": "feldkirch",
					"stores": [
						{
							"name": "Vero Moda  kreuzgasse",
							"adres": "Kreuzgasse 10\n6800 Feldkirch\nAustria"
						}
					]
				},
				{
					"name": "Krems",
					"slug": "krems",
					"stores": [
						{
							"name": "Vero Moda wiener strasse ",
							"adres": "Wiener Strasse 91\n3500 Krems\nAustria"
						}
					]
				},
				{
					"name": "Linz",
					"slug": "linz",
					"stores": [
						{
							"name": "Vero Moda landstrasse",
							"adres": "Landstrasse 39\n4020 Linz\nAustria"
						},
						{
							"name": "Vero Moda hauptstrasse",
							"adres": "Haupstrasse 54\n4040 Linz\nAustria"
						}
					]
				},
				{
					"name": "Salzburg",
					"slug": "salzburg",
					"stores": [
						{
							"name": "Vero Moda getreidegasse",
							"adres": "Getreidegasse 15\n5020 Salzburg\nAustria"
						},
						{
							"name": "Vero Moda europastrasse",
							"adres": "Europastrasse 1\nGround Floor\n5018 Salzburg\nAustria"
						}
					]
				},
				{
					"name": "Innsbruck",
					"slug": "innsbruck",
					"stores": [
						{
							"name": "Vero Moda/jack & jones",
							"adres": "Amraser-See-Strasse 56a\n6020 Innsbruck\nAustria"
						}
					]
				},
				{
					"name": "Seiersberg",
					"slug": "seiersberg",
					"stores": [
						{
							"name": "Vero Moda/jack & jones shopping city",
							"adres": "Shopping City Seiersberg 1-9\n8055 Seiersberg\nAustria"
						}
					]
				},
				{
					"name": "Villach",
					"slug": "villach",
					"stores": [
						{
							"name": "Vero Moda/jack & jones karnter strasse",
							"adres": "Kärntner Strasse 34\n(Atrio Villach og nr. 109+155)\n9500 Villach\nAustria"
						}
					]
				},
				{
					"name": "Wien",
					"slug": "wien",
					"stores": [
						{
							"name": "Vero Moda/jack & jones wagramer strasse ",
							"adres": "Wagramer Strasse 81\n1220 Wien\nAustria"
						},
						{
							"name": "Vero Moda  mariahilferstrasse ",
							"adres": "Mariahilferstrasse 36\n1070 Wien\nAustria"
						},
						{
							"name": "Vero Moda mariahilferstrasse ",
							"adres": "Mariahilferstrasse 113\n1060 Wien\nAustria"
						}
					]
				},
				{
					"name": "Vosendorf",
					"slug": "vosendorf",
					"stores": [
						{
							"name": "Vero Moda/jack & jones scs",
							"adres": "SCS-Straβe 1\n2331 Vösendorf\nAustria"
						}
					]
				},
				{
					"name": "Pasching",
					"slug": "pasching",
					"stores": [
						{
							"name": "Vero Moda pluscity pluskaufstrasse\n",
							"adres": ",Pluskaufstr. 7\n4061 Pasching\nAustria"
						}
					]
				},
				{
					"name": "Vocklabruck",
					"slug": "vocklabruck",
					"stores": [
						{
							"name": "Vero Moda linzer strasse",
							"adres": "Linzer Str. 50\n4840 Vöcklabruck\nAustria"
						}
					]
				}
			]
		},
		{
			"name": "Bahrain",
			"slug": "bahrain",
			"cities": [
				{
					"name": "Bahrain",
					"slug": "bahrain",
					"stores": [
						{
							"name": "jack&jones/Vero Moda city centre",
							"adres": "Seef Area, City Center\nSeef 11816\nBahrain"
						}
					]
				}
			]
		},
		{
			"name": "Belarus",
			"slug": "belarus",
			"cities": [
				{
					"name": "Minsk",
					"slug": "minsk",
					"stores": [
						{
							"name": "Vero Moda/jack&jones  stolitsa mall ",
							"adres": "Stolitsa Mall - Nezavisimosty Square\n220030 Minsk\nBelarus"
						}
					]
				}
			]
		},
		{
			"name": "Bulgaria",
			"slug": "bulgaria",
			"cities": [
				{
					"name": "Sofia",
					"slug": "sofia",
					"stores": [
						{
							"name": "selected brands ltd ",
							"adres": "Vitosha Street 45\n1000 Sofia\nBulgaria"
						}
					]
				}
			]
		},
		{
			"name": "Canada",
			"slug": "canada",
			"cities": [
				{
					"name": "Montreal",
					"slug": "montreal",
					"stores": [
						{
							"name": "bestseller canada inc",
							"adres": "225 A De Liége Ouest\nH2P 1H4 Montreal\nCanada"
						}
					]
				}
			]
		},
		{
			"name": "Czech republic",
			"slug": "czech-republic",
			"cities": [
				{
					"name": "Online",
					"slug": "online",
					"stores": [
						{
							"name": "ZOOT A.S.",
							"adres": "<a target=\"_blank\" href=\"https://www.zoot.cz/znacka/18542/noisy-may\">Shop online</a>"
						}
					]
				},
				{
					"name": "Ricany",
					"slug": "ricany",
					"stores": [
						{
							"name": "zoot ",
							"adres": "Cernokostelecka 2246\n251 01 Radosovice-ricany\nCzech Republic"
						}
					]
				}
			]
		},
		{
			"name": "Denmark",
			"slug": "denmark",
			"cities": [
				{
					"name": "Aarhus",
					"slug": "aarhus",
					"stores": [
						{
							"name": "bestseller ",
							"adres": "Ryesgade 9\n8000 Aarhus\nDenmark"
						},
						{
							"name": "Vero Moda storcenter nord ",
							"adres": "Finlandsgade 17\n8200 Aarhus N\nDenmark"
						}
					]
				},
				{
					"name": "Billund",
					"slug": "billund",
					"stores": [
						{
							"name": "billund airport ",
							"adres": "Passagerterminalen 10\n7190 Billund\nDenmark"
						}
					]
				},
				{
					"name": "Brande",
					"slug": "brande",
					"stores": [
						{
							"name": "bestseller",
							"adres": "Jernbanegade 9 st. th.\n7330 Brande\nDenmark"
						}
					]
				},
				{
					"name": "Randers",
					"slug": "randers",
					"stores": [
						{
							"name": "bestseller",
							"adres": "Rådhusstræde 13\n8900 Randers\nDenmark"
						}
					]
				},
				{
					"name": "Roskilde",
					"slug": "roskilde",
					"stores": [
						{
							"name": "bestseller ",
							"adres": "Algade 43 D\n4000 Roskilde\nDenmark"
						},
						{
							"name": "Vero Moda ro's torv",
							"adres": "Københavnsvej 29-39\n4000 Roskilde\nDenmark"
						}
					]
				},
				{
					"name": "Silkeborg",
					"slug": "silkeborg",
					"stores": [
						{
							"name": "bestseller",
							"adres": "Vestergade 24\n8600 Silkeborg\nDenmark"
						}
					]
				},
				{
					"name": "Vejle",
					"slug": "vejle",
					"stores": [
						{
							"name": "bestseller",
							"adres": "Søndergade 1\n7100 Vejle\nDenmark"
						}
					]
				},
				{
					"name": "Lemvig",
					"slug": "lemvig",
					"stores": [
						{
							"name": "butik helle ",
							"adres": "Vestergade 7\n7620 Lemvig\nDenmark"
						}
					]
				},
				{
					"name": "Albertslund",
					"slug": "albertslund",
					"stores": [
						{
							"name": "Vero Moda  bytorvet",
							"adres": "Bytorvet 29\n2620 Albertslund\nDenmark"
						}
					]
				},
				{
					"name": "Bronderslev",
					"slug": "bronderslev",
					"stores": [
						{
							"name": "Vero Moda  mejlstedgade ",
							"adres": "Mejlstedgade 2-4\n9700 Brønderslev\nDenmark"
						}
					]
				},
				{
					"name": "Faborg",
					"slug": "faborg",
					"stores": [
						{
							"name": "Vero Moda  ostergade ",
							"adres": "Østergade 25\n5600 Fåborg\nDenmark"
						}
					]
				},
				{
					"name": "Grena",
					"slug": "grena",
					"stores": [
						{
							"name": "Vero Moda torvet",
							"adres": "Torvet 6\n8500 Grenå\nDenmark"
						}
					]
				},
				{
					"name": "Haderslev",
					"slug": "haderslev",
					"stores": [
						{
							"name": "Vero Moda storegade ",
							"adres": "Storegade 14 A\n6100 Haderslev\nDenmark"
						}
					]
				},
				{
					"name": "Helsinge",
					"slug": "helsinge",
					"stores": [
						{
							"name": "Vero Moda ostergade ",
							"adres": "Østergade 25\n3200 Helsinge\nDenmark"
						}
					]
				},
				{
					"name": "Herlev",
					"slug": "herlev",
					"stores": [
						{
							"name": "Vero Moda  herlev torv",
							"adres": "Herlev Torv 2\n2730 Herlev\nDenmark"
						}
					]
				},
				{
					"name": "Holbaek",
					"slug": "holbaek",
					"stores": [
						{
							"name": "Vero Moda ahlgade ",
							"adres": "Ahlgade 52\n4300 Holbæk\nDenmark"
						}
					]
				},
				{
					"name": "Greve",
					"slug": "greve",
					"stores": [
						{
							"name": "Vero Moda bilka hundige storcenter",
							"adres": "Over Bølgen 5B\n2670 Greve\nDenmark"
						}
					]
				},
				{
					"name": "Kalundborg",
					"slug": "kalundborg",
					"stores": [
						{
							"name": "Vero Moda kordilgade ",
							"adres": "Kordilgade 26\n4400 Kalundborg\nDenmark"
						}
					]
				},
				{
					"name": "Kolding",
					"slug": "kolding",
					"stores": [
						{
							"name": "Vero Moda skovvangen",
							"adres": "Skovvangen 42\n6000 Kolding\nDenmark"
						},
						{
							"name": "Vero Moda sondergade ",
							"adres": "Søndergade 2\n6000 Kolding\nDenmark"
						}
					]
				},
				{
					"name": "Koge",
					"slug": "koge",
					"stores": [
						{
							"name": "Vero Moda torvet",
							"adres": "Torvet 7\n4600 Køge\nDenmark"
						}
					]
				},
				{
					"name": "Copenhagen",
					"slug": "copenhagen",
					"stores": [
						{
							"name": "Vero Moda norrebro bycenter",
							"adres": "Lygten 2 D\n2400 København NV\nDenmark"
						},
						{
							"name": "Vero Moda arne jacobsens alle ",
							"adres": "Arne Jacobsens Alle 12\n2300 København S\nDenmark"
						},
						{
							"name": "Vero Moda fisketorvet copenhagen mall",
							"adres": "Kalvebod Brygge 59\nKøbenhavn V\nDenmark"
						},
						{
							"name": "Vero Moda vesterbrogade ",
							"adres": "Vesterbrogade 28\n1620 København V\nDenmark"
						},
						{
							"name": "Vero Moda osterbrogade ",
							"adres": "Østerbrogade 84 St. Th.\n2100 København Ø\nDenmark"
						}
					]
				},
				{
					"name": "Slagelse",
					"slug": "slagelse",
					"stores": [
						{
							"name": "Vero Moda nytorv",
							"adres": "Nytorv 10\n4200 Slagelse\nDenmark"
						}
					]
				},
				{
					"name": "Solrod",
					"slug": "solrod",
					"stores": [
						{
							"name": "Vero Moda solrod center",
							"adres": "Solrød Center 14\n2680 Solrød\nDenmark"
						}
					]
				},
				{
					"name": "Tonder",
					"slug": "tonder",
					"stores": [
						{
							"name": "Vero Moda vestergade ",
							"adres": "Vestergade 26\n6270 Tønder\nDenmark"
						}
					]
				},
				{
					"name": "Varde",
					"slug": "varde",
					"stores": [
						{
							"name": "Vero Moda kraemmergade ",
							"adres": "Kræmmergade 6\n6800 Varde\nDenmark"
						}
					]
				},
				{
					"name": "Rodovre",
					"slug": "rodovre",
					"stores": [
						{
							"name": "Vero Moda/only rodovre centrum",
							"adres": "Rødovre Centrum 131\n2610 Rødovre\nDenmark"
						}
					]
				},
				{
					"name": "Aars",
					"slug": "aars",
					"stores": [
						{
							"name": "Vero Moda himmerlandsgade ",
							"adres": "Himmerlandsgade 65\n9600 Aars\nDenmark"
						}
					]
				},
				{
					"name": "Frederikshavn",
					"slug": "frederikshavn",
					"stores": [
						{
							"name": "Vero Moda danmarksgade ",
							"adres": "Danmarksgade 59\n9900 Frederikshavn\nDenmark"
						}
					]
				},
				{
					"name": "Frederikssund",
					"slug": "frederikssund",
					"stores": [
						{
							"name": "Vero Moda sillebroen shopping",
							"adres": "Nygade 1\nSillebroen - Butik 2.3\n3600 Frederikssund\nDenmark"
						}
					]
				},
				{
					"name": "Glostrup",
					"slug": "glostrup",
					"stores": [
						{
							"name": "Vero Moda glostrup shoppingcenter",
							"adres": "Glostrup Shoppingcenter 101\n2600 Glostrup\nDenmark"
						}
					]
				},
				{
					"name": "Hvidovre",
					"slug": "hvidovre",
					"stores": [
						{
							"name": "Vero Moda hvidovre c",
							"adres": "Hvidovrevej 57\n2650 Hvidovre\nDenmark"
						}
					]
				},
				{
					"name": "Horsholm",
					"slug": "horsholm",
					"stores": [
						{
							"name": "Vero Moda horsholm midtpunkt",
							"adres": "Hørsholm Midtpunkt 184\n2970 Hørsholm\nDenmark"
						}
					]
				},
				{
					"name": "Naestved",
					"slug": "naestved",
					"stores": [
						{
							"name": "Vero Moda hjultorv",
							"adres": "Hjultorv 6\n4700 Næstved\nDenmark"
						},
						{
							"name": "Vero Moda naestved storcenter",
							"adres": "Næstved Storcenter 3\n4700 Næstved\nDenmark"
						}
					]
				},
				{
					"name": "Odense",
					"slug": "odense",
					"stores": [
						{
							"name": "Vero Moda tarup center",
							"adres": "Rugvang 36\n5210 Odense NV\nDenmark"
						}
					]
				},
				{
					"name": "Ringsted",
					"slug": "ringsted",
					"stores": [
						{
							"name": "Vero Moda klosterparks alle ",
							"adres": "Klosterparks Allé 10\n4100 Ringsted\nDenmark"
						}
					]
				},
				{
					"name": "Stenlose",
					"slug": "stenlose",
					"stores": [
						{
							"name": "Vero Moda egedal centret",
							"adres": "Egedal Centret 61\n3660 Stenløse\nDenmark"
						}
					]
				},
				{
					"name": "Sonderborg",
					"slug": "sonderborg",
					"stores": [
						{
							"name": "Vero Moda ostergade ",
							"adres": "Østergade 4\nBorgen\n6400 Sønderborg\nDenmark"
						}
					]
				},
				{
					"name": "Valby",
					"slug": "valby",
					"stores": [
						{
							"name": "Vero Moda spinderiet",
							"adres": "Spinderigade 10\n2500 Valby\nDenmark"
						}
					]
				}
			]
		},
		{
			"name": "Egypt",
			"slug": "egypt",
			"cities": [
				{
					"name": "Heliopolis",
					"slug": "heliopolis",
					"stores": [
						{
							"name": "stars centre",
							"adres": "Omar Ibn ALKhattab street"
						}
					]
				},
				{
					"name": "Alexandria",
					"slug": "alexandria",
					"stores": [
						{
							"name": "jack&jones/Vero Moda alexandria city center",
							"adres": "Alexandria-Cairo desert road\nAlexandria\nEgypt"
						}
					]
				},
				{
					"name": "Cairo",
					"slug": "cairo",
					"stores": [
						{
							"name": "Vero Moda mohandeseen",
							"adres": "Mouhandessen\nJiza 11371\nEgypt"
						},
						{
							"name": "Vero Moda maadi city center",
							"adres": "Al Me´raj City, Kattameyia Ring Rd.\nMaadi City Center\nCairo 11371\nEgypt"
						},
						{
							"name": "Vero Moda / jack&jones mall of arabia",
							"adres": "Juhayna Square\nCairo 11371\nEgypt"
						},
						{
							"name": "Vero Moda / jack&jones city stars center",
							"adres": "Nasser City - Stars Center\nCairo 11371\nEgypt"
						},
						{
							"name": "Vero Moda / jack&jones dandy mega mall",
							"adres": "Bld. K.M 28 Cairo Alex Desert rd\nCairo 11371\nEgypt"
						},
						{
							"name": "Vero Moda city star project ",
							"adres": "Nasser City - Stars Center\n212/213 A 157 Retail Level\nCairo 11371\nEgypt"
						}
					]
				}
			]
		},
		{
			"name": "Faroe islands",
			"slug": "faroe-islands",
			"cities": [
				{
					"name": "Torshavn",
					"slug": "torshavn",
					"stores": [
						{
							"name": "Vero Moda  boutique good luck ",
							"adres": "Boutique Good Luck - Shop 16\n110 Torshavn\nFaroe Islands"
						}
					]
				}
			]
		},
		{
			"name": "Finland",
			"slug": "finland",
			"cities": [
				{
					"name": "Espoo",
					"slug": "espoo",
					"stores": [
						{
							"name": "bestseller retail finland oy",
							"adres": "Lars Sonckin Kaari 6\n02600 Espoo\nFinland"
						}
					]
				},
				{
					"name": "Kokkola",
					"slug": "kokkola",
					"stores": [
						{
							"name": "mick's",
							"adres": "Tehtaankatu 3\n67100 Kokkola\nFinland"
						}
					]
				},
				{
					"name": "Oulu",
					"slug": "oulu",
					"stores": [
						{
							"name": "mick's",
							"adres": "Uusikatu 21 A\n90100 Oulu\nFinland"
						}
					]
				},
				{
					"name": "Kempele",
					"slug": "kempele",
					"stores": [
						{
							"name": "mick's zeppelin",
							"adres": "Zeppelinintie 1\n90450 Kempele\nFinland"
						}
					]
				},
				{
					"name": "Kerava",
					"slug": "kerava",
					"stores": [
						{
							"name": "sokos noisy may",
							"adres": "INEX KT-Logistiikkakeskus\nKeuksuontie 1\n04220 Kerava\nFinland"
						}
					]
				}
			]
		},
		{
			"name": "France",
			"slug": "france",
			"cities": [
				{
					"name": "Saint paul les dox",
					"slug": "saint-paul-les-dox",
					"stores": [
						{
							"name": "marie-sarah ",
							"adres": "Route de Mont de Marssan-22 Bd St Vincent de Paul\n40990 Saint Paul Les Dax\nFrance"
						}
					]
				},
				{
					"name": "Serris",
					"slug": "serris",
					"stores": [
						{
							"name": "Vero Moda / jack&jones centre commercial val d'europe",
							"adres": "14 Cours du Danube\n77711 Marne la Vallée\nFrance"
						}
					]
				}
			]
		},
		{
			"name": "Germany",
			"slug": "germany",
			"cities": [
				{
					"name": "Online",
					"slug": "online",
					"stores": [
						{
							"name": "Defshop",
							"adres": "<a target=\"_blank\" href=\"https://www.def-shop.dk/index.php?rf=1&search=noisy+may\">Shop online</a>"
						},
						{
							"name": "About you",
							"adres": "<a target=\"_blank\" href=\"https://www.aboutyou.de/about/brand/noisy-may?category=20201\">Shop online</a>"
						},
						{
							"name": "Edited",
							"adres": "<a target=\"_blank\" href=\"https://www.edited.de/women/brands/noisy-may\">Shop online</a>"
						},
						{
							"name": "Rudolf WÖHRL AG",
							"adres": "<a target=\"_blank\" href=\"https://www.woehrl.de\">Shop online</a>"
						},
						{
							"name": "Zalando",
							"adres": "<a target=\"_blank\" href=\"https://www.zalando.dk/noisy-may-shop-damer/?sc=false&_q=noisy+may&o=122\">Shop online</a>"
						}
					]
				},
				{
					"name": "Northeim",
					"slug": "northeim",
					"stores": [
						{
							"name": "city center",
							"adres": "Grafenhof 4\nCity Center\n37154 Northeim\nGermany"
						}
					]
				},
				{
					"name": "Dietzenbach",
					"slug": "dietzenbach",
					"stores": [
						{
							"name": "lamoda",
							"adres": "Borsigstraβe 1-3\n63128 Dietzenbach\nGermany"
						}
					]
				},
				{
					"name": "Haldensleben",
					"slug": "haldensleben",
					"stores": [
						{
							"name": "",
							"adres": "Am Südhafen 1\n39340 Haldensleben\nGermany"
						}
					]
				},
				{
					"name": "Nurnberg",
					"slug": "nurnberg",
					"stores": [
						{
							"name": "rudolf wohrl ",
							"adres": "Lina-ammon-str. 10\n90471 Nürnberg\nGermany"
						}
					]
				},
				{
					"name": "Ahlen",
					"slug": "ahlen",
					"stores": [
						{
							"name": "Vero Moda/jack & jones ",
							"adres": "Oststrasse 47-49\n59227 Ahlen\nGermany"
						}
					]
				},
				{
					"name": "Berlin",
					"slug": "berlin",
					"stores": [
						{
							"name": "Vero Moda/jack & jones  gesundbrunnen center",
							"adres": "Badstrasse 4\n13357 Berlin\nGermany"
						},
						{
							"name": "Vero Moda/jack & jones  potsdamer platz",
							"adres": "Alte Potsdamer Strasse 7\nPotsdamer Platz Arkaden\n10785 Berlin\nGermany"
						},
						{
							"name": "Vero Moda/jack & jones  tauentzienstrasse ",
							"adres": "Tauentzienstrasse 13a\n10789 Berlin\nGermany"
						},
						{
							"name": "Vero Moda/jack & jones  titania palast",
							"adres": "Schlossstrasse 4-5\n12163 Berlin\nGermany"
						},
						{
							"name": "Vero Moda/jack & jones  berlin alexa",
							"adres": "Gruner Strasse 20\n10179 Berlin\nGermany"
						},
						{
							"name": "Vero Moda/jack & jones berlin neukolln",
							"adres": "Karl-Marx Strasse 66\n12043 Berlin\nGermany"
						},
						{
							"name": "Vero Moda eastgate",
							"adres": "Berlin Eastgate, Marzahner Promenade 1A\n12679 Berlin\nGermany"
						},
						{
							"name": "Vero Moda leipziger platz",
							"adres": "Leipziger Platz 12\n10117 Berlin\nGermany"
						},
						{
							"name": "Vero Moda spandau ",
							"adres": "Klosterstr. 3\n13581 Berlin\nGermany"
						},
						{
							"name": "Vero Moda jack & jones wilmersdorfer arcaden ",
							"adres": "Wilmersdorfer Strasse 46\n10627 Berlin\nGermany"
						}
					]
				},
				{
					"name": "Erlangen",
					"slug": "erlangen",
					"stores": [
						{
							"name": "Vero Moda/jack & jones ",
							"adres": "Nürnberger Str. 7\n91052 Erlangen\nGermany"
						}
					]
				},
				{
					"name": "Esslingen",
					"slug": "esslingen",
					"stores": [
						{
							"name": "Vero Moda/jack & jones ",
							"adres": "Berliner Strasse 2\n73728 Esslingen\nGermany"
						}
					]
				},
				{
					"name": "Frankfurt",
					"slug": "frankfurt",
					"stores": [
						{
							"name": "Vero Moda/jack & jones ",
							"adres": "Hauptwache 11\n60313 Frankfurt\nGermany"
						}
					]
				},
				{
					"name": "Gelsenkirchen",
					"slug": "gelsenkirchen",
					"stores": [
						{
							"name": "Vero Moda/jack & jones ",
							"adres": "Bahnhofstr. 69\n45879 Gelsenkirchen\nGermany"
						},
						{
							"name": "Vero Moda hochstrasse  ",
							"adres": "Hochstraβe 23\n45894 Gelsenkirchen\nGermany"
						}
					]
				},
				{
					"name": "Hamburg",
					"slug": "hamburg",
					"stores": [
						{
							"name": "Vero Moda/jack & jones  jungfernstieg",
							"adres": "Jungfernstieg 40\n20354 Hamburg\nGermany"
						},
						{
							"name": "Vero Moda/jack & jones  spitalerstrasse",
							"adres": "Spitalerstrasse 6\n20095 Hamburg\nGermany"
						},
						{
							"name": "Vero Moda bergedorfer strasse",
							"adres": "Bergedorfer Str. 105\n21029 Hamburg\nGermany"
						}
					]
				},
				{
					"name": "Heidelberg",
					"slug": "heidelberg",
					"stores": [
						{
							"name": "Vero Moda/jack & jones ",
							"adres": "Haupstrasse 23\n69117 Heidelberg\nGermany"
						}
					]
				},
				{
					"name": "Ingolstadt",
					"slug": "ingolstadt",
					"stores": [
						{
							"name": "Vero Moda/jack & jones ",
							"adres": "Am Westpark 6\n85057 Ingolstadt\nGermany"
						}
					]
				},
				{
					"name": "Kempten",
					"slug": "kempten",
					"stores": [
						{
							"name": "Vero Moda/jack & jones ",
							"adres": "Fischerstraβe 15\n87435 Kempten\nGermany"
						},
						{
							"name": "Vero Moda forum allgau ",
							"adres": "Forum Allgäu\n87435 Kempten\nGermany"
						}
					]
				},
				{
					"name": "Koln",
					"slug": "koln",
					"stores": [
						{
							"name": "Vero Moda/jack & jones hohe strasse 68-82",
							"adres": "Hohe Str. 68-82\n50667 Köln\nGermany"
						},
						{
							"name": "Vero Moda/jack & jones  hohestrasse 115",
							"adres": "Hohestrasse 115\n50667 Köln\nGermany"
						},
						{
							"name": "Vero Moda/jack & jones  schildergasse ",
							"adres": "Schildergasse 98-102\n50667 Köln\nGermany"
						}
					]
				},
				{
					"name": "Ludwigsburg",
					"slug": "ludwigsburg",
					"stores": [
						{
							"name": "Vero Moda/jack & jones ",
							"adres": "Wilhelmstraβe 26\n71638 Ludwigsburg\nGermany"
						},
						{
							"name": "Vero Moda/jack & jones marstall center",
							"adres": "Marstallstraβe 1\n71634 Ludwigsburg\nGermany"
						}
					]
				},
				{
					"name": "Luneburg",
					"slug": "luneburg",
					"stores": [
						{
							"name": "Vero Moda/jack & jones ",
							"adres": "Grosse Bäckerstrasse 25\n21335 Lüneburg\nGermany"
						}
					]
				},
				{
					"name": "Mainz",
					"slug": "mainz",
					"stores": [
						{
							"name": "Vero Moda/jack & jones ",
							"adres": "Schusterstr. 22-24\n55116 Mainz\nGermany"
						}
					]
				},
				{
					"name": "Mannheim",
					"slug": "mannheim",
					"stores": [
						{
							"name": "Vero Moda/jack & jones ",
							"adres": "Planken 0 7,8\n68161 Mannheim\nGermany"
						}
					]
				},
				{
					"name": "Munster",
					"slug": "munster",
					"stores": [
						{
							"name": "Vero Moda/jack & jones ",
							"adres": "Ludgeristrasse 6\n48143 Münster\nGermany"
						},
						{
							"name": "Vero Moda/jack & jones  ludgeristrasse ",
							"adres": "Ludgeristrasse 32-33\n48143 Münster\nGermany"
						}
					]
				},
				{
					"name": "Neuss",
					"slug": "neuss",
					"stores": [
						{
							"name": "Vero Moda/jack & jones ",
							"adres": "Büchel 22-24\n41460 Neuss\nGermany"
						}
					]
				},
				{
					"name": "Offenbach am main",
					"slug": "offenbach-am-main",
					"stores": [
						{
							"name": "Vero Moda/jack & jones ",
							"adres": "Aliceplatz 11\n63065 Offenbach am Main\nGermany"
						}
					]
				},
				{
					"name": "Osnabruck",
					"slug": "osnabruck",
					"stores": [
						{
							"name": "Vero Moda/jack & jones ",
							"adres": "Groβe Str. 61\n49074 Osnabrück\nGermany"
						}
					]
				},
				{
					"name": "Paderborn",
					"slug": "paderborn",
					"stores": [
						{
							"name": "Vero Moda/jack & jones ",
							"adres": "Marienplatz 7\n33098 Paderborn\nGermany"
						}
					]
				},
				{
					"name": "Peine",
					"slug": "peine",
					"stores": [
						{
							"name": "Vero Moda/jack & jones ",
							"adres": "Breite Strasse 41\n31224 Peine\nGermany"
						}
					]
				},
				{
					"name": "Remscheid",
					"slug": "remscheid",
					"stores": [
						{
							"name": "Vero Moda/jack & jones ",
							"adres": "Theodor-Heuss-Platz 7\n42853 Remscheid\nGermany"
						}
					]
				},
				{
					"name": "Speyer",
					"slug": "speyer",
					"stores": [
						{
							"name": "Vero Moda/jack & jones  postgalerie",
							"adres": "Postplatz 1\n67346 Speyer\nGermany"
						}
					]
				},
				{
					"name": "Stuttgart",
					"slug": "stuttgart",
					"stores": [
						{
							"name": "Vero Moda/jack & jones canstatter carree",
							"adres": "Wildunger Strasse 1-4\n70372 Stuttgart\nGermany"
						},
						{
							"name": "Vero Moda/jack & jones  gerber ",
							"adres": "Tübinger Strasse 28\n70178 Stuttgart\nGermany"
						},
						{
							"name": "Vero Moda/jack & jones  milaneo",
							"adres": "Mailänder Platz 7\n70173 Stuttgart\nGermany"
						},
						{
							"name": "Vero Moda konigsstrasse ",
							"adres": "Königstraβe 58\n70173 Stuttgart\nGermany"
						}
					]
				},
				{
					"name": "Trier",
					"slug": "trier",
					"stores": [
						{
							"name": "Vero Moda/jack & jones trier 2 ",
							"adres": "Am Kornmarkt 4\n54290 Trier\nGermany"
						}
					]
				},
				{
					"name": "Weiterstadt",
					"slug": "weiterstadt",
					"stores": [
						{
							"name": "Vero Moda/jack & jones\n",
							"adres": ",Gutenbergstrasse 5\n64331 Weiterstadt\nGermany"
						}
					]
				},
				{
					"name": "Wiesbaden",
					"slug": "wiesbaden",
					"stores": [
						{
							"name": "Vero Moda/jack & jones ",
							"adres": "Friedrichstrasse 51\n65185 Wiesbaden\nGermany"
						}
					]
				},
				{
					"name": "Wildau",
					"slug": "wildau",
					"stores": [
						{
							"name": "Vero Moda/jack & jones  a10 center wildau",
							"adres": "Chausseestrasse 1\n15745 Wildau\nGermany"
						}
					]
				},
				{
					"name": "Worms",
					"slug": "worms",
					"stores": [
						{
							"name": "Vero Moda/jack & jones ",
							"adres": "Kämmererstr. 29\n67547 Worms\nGermany"
						}
					]
				},
				{
					"name": "Wuppertal-barmen",
					"slug": "wuppertal-barmen",
					"stores": [
						{
							"name": "Vero Moda/jack & jones ",
							"adres": "Wert 23\n42275 Wuppertal-Barmen\nGermany"
						}
					]
				},
				{
					"name": "Freiburg",
					"slug": "freiburg",
					"stores": [
						{
							"name": "Vero Moda kaiser joseph strasse ",
							"adres": "Kaiser-Joseph-Straβe 227\n79098 Freiburg\nGermany"
						}
					]
				},
				{
					"name": "Hanau",
					"slug": "hanau",
					"stores": [
						{
							"name": "Vero Moda forum hanau ",
							"adres": "Am Freiheitsplatz\nForum Hanau\n63450 Hanau\nGermany"
						}
					]
				},
				{
					"name": "Heilbronn",
					"slug": "heilbronn",
					"stores": [
						{
							"name": "Vero Moda deutschhofstrasse ",
							"adres": "Deutschhofstr. 19\n74072 Heilbronn\nGermany"
						}
					]
				},
				{
					"name": "Frankfurt am main",
					"slug": "frankfurt-am-main",
					"stores": [
						{
							"name": "Vero Moda hessen center",
							"adres": "Borsigallee 26\n60388 Frankfurt am Main\nGermany"
						},
						{
							"name": "Vero Moda / jack & jones nordwest zentrum ",
							"adres": "Limescorso 8\n60439 Frankfurt am Main\nGermany"
						}
					]
				},
				{
					"name": "Sulzbach",
					"slug": "sulzbach",
					"stores": [
						{
							"name": "Vero Moda main taunus ",
							"adres": "Am Main-Taunus-Zentrum\n65843 Sulzbach\nGermany"
						}
					]
				},
				{
					"name": "Minden",
					"slug": "minden",
					"stores": [
						{
							"name": "Vero Moda backerstrasse ",
							"adres": "Bäckerstr. 8-10\n32423 Minden\nGermany"
						}
					]
				},
				{
					"name": "Mulheim",
					"slug": "mulheim",
					"stores": [
						{
							"name": "Vero Moda rhien ruhr zentrum ",
							"adres": "Humboldtring 13\n45472 Mülheim\nGermany"
						}
					]
				},
				{
					"name": "Neu-isenburg",
					"slug": "neu-isenburg",
					"stores": [
						{
							"name": "Vero Moda hermesstrasse ",
							"adres": "Hermesstrasse 4\n63263 Neu-Isenburg\nGermany"
						}
					]
				},
				{
					"name": "Neuwied",
					"slug": "neuwied",
					"stores": [
						{
							"name": "Vero Moda mittelstrasse ",
							"adres": "Mittelstrasse 44\n56564 Neuwied\nGermany"
						}
					]
				},
				{
					"name": "Braunschweig",
					"slug": "braunschweig",
					"stores": [
						{
							"name": "Vero Moda / jack & jones damm",
							"adres": "Damm 17\n38100 Braunschweig\nGermany"
						},
						{
							"name": "Vero Moda  schloss arkaden ",
							"adres": "Ritterbrunnen 1\n38100 Braunschweig\nGermany"
						}
					]
				},
				{
					"name": "Erfurt",
					"slug": "erfurt",
					"stores": [
						{
							"name": "Vero Moda / jack & jones erfurt 2",
							"adres": "Anger 66-73\n99084 Erfurt\nGermany"
						},
						{
							"name": "zalando logistics ",
							"adres": "Büβlebener Grenze\n99098 Erfurt\nGermany"
						}
					]
				},
				{
					"name": "Gutersloth",
					"slug": "gutersloth",
					"stores": [
						{
							"name": "Vero Moda / jack & jones berliner strasse",
							"adres": "Berliner Strasse 26\n33330 Gütersloth\nGermany"
						}
					]
				},
				{
					"name": "Hurth",
					"slug": "hurth",
					"stores": [
						{
							"name": "Vero Moda / jack & jones hurth park ",
							"adres": "Parkstraβe\nHürth Park\n50354 Hürth\nGermany"
						}
					]
				},
				{
					"name": "Ingoldstadt",
					"slug": "ingoldstadt",
					"stores": [
						{
							"name": "Vero Moda / jack & jones ingolstadt city ",
							"adres": "Ludwigstrasse 14\n85049 Ingolstadt\nGermany"
						}
					]
				},
				{
					"name": "Jena",
					"slug": "jena",
					"stores": [
						{
							"name": "Vero Moda / jack & jones goethestrasse ",
							"adres": "Goethestrasse 3\n07743 Jena\nGermany"
						}
					]
				},
				{
					"name": "Karlsruhe",
					"slug": "karlsruhe",
					"stores": [
						{
							"name": "Vero Moda / jack & jones kaiserstrasse ",
							"adres": "Kaiserstr. 120\n76133 Karlsruhe\nGermany"
						},
						{
							"name": "Vero Moda ettlinger tor",
							"adres": "Platz 1\n76133 Karlsruhe\nGermany"
						}
					]
				},
				{
					"name": "Lorrach",
					"slug": "lorrach",
					"stores": [
						{
							"name": "Vero Moda / jack & jones turmstrasse ",
							"adres": "Turmstrasse 10\n79539 Lörrach\nGermany"
						}
					]
				},
				{
					"name": "Magdeburg",
					"slug": "magdeburg",
					"stores": [
						{
							"name": "Vero Moda / jack & jones alleecenter ",
							"adres": "Ernst Reuter Allee 11\n39104 Magdeburg\nGermany"
						}
					]
				},
				{
					"name": "Neumarkt",
					"slug": "neumarkt",
					"stores": [
						{
							"name": "Vero Moda / jack & jones neuer markt ",
							"adres": "Dammstraβe 3\n92318 Neumarkt\nGermany"
						}
					]
				},
				{
					"name": "Neunkirchen",
					"slug": "neunkirchen",
					"stores": [
						{
							"name": "Vero Moda / jack & jones stummplatz ",
							"adres": "Stummplatz 1\n66538 Neunkirchen\nGermany"
						}
					]
				},
				{
					"name": "Reutlingen",
					"slug": "reutlingen",
					"stores": [
						{
							"name": "Vero Moda / jack & jones wilhelmstrasse ",
							"adres": "Wilhelmstrasse 17-23\n72764 Reutlingen\nGermany"
						}
					]
				},
				{
					"name": "Saarbrucken",
					"slug": "saarbrucken",
					"stores": [
						{
							"name": "Vero Moda/jack & jones bahnhofstrasse ",
							"adres": "Bahnhofstrasse 89\n66111 Saarbrücken\nGermany"
						},
						{
							"name": "Vero Moda / jack & jones trierer strasse ",
							"adres": "Trierer Straβe 1\n33111 Saarbrücken\nGermany"
						}
					]
				},
				{
					"name": "Schweinfurt",
					"slug": "schweinfurt",
					"stores": [
						{
							"name": "Vero Moda / jack & jones schrammstrasse ",
							"adres": "Schrammstr. 0\n97421 Schweinfurt\nGermany"
						}
					]
				},
				{
					"name": "Sindelfingen",
					"slug": "sindelfingen",
					"stores": [
						{
							"name": "Vero Moda / jack & jones breuningerland ",
							"adres": "Tilsiterstr. 15\n71065 Sindelfingen\nGermany"
						}
					]
				},
				{
					"name": "Ulm",
					"slug": "ulm",
					"stores": [
						{
							"name": "Vero Moda / jack & jones hirschstrasse ",
							"adres": "Hirschstrasse 12\n89073 Ulm\nGermany"
						}
					]
				},
				{
					"name": "Greifswald",
					"slug": "greifswald",
					"stores": [
						{
							"name": "Vero Moda fischmarkt ",
							"adres": "Fischmarkt 30\n17489 Greifswald\nGermany"
						}
					]
				},
				{
					"name": "Ibbenburen",
					"slug": "ibbenburen",
					"stores": [
						{
							"name": "Vero Moda grosse strasse ",
							"adres": "Grosse str. 5\n49477 Ibbenburen\nGermany"
						}
					]
				},
				{
					"name": "Lingen",
					"slug": "lingen",
					"stores": [
						{
							"name": "Vero Moda lockentor passage",
							"adres": "Lookentorpassage 22\n49808 Lingen\nGermany"
						}
					]
				},
				{
					"name": "Oldenburg",
					"slug": "oldenburg",
					"stores": [
						{
							"name": "Vero Moda lange strasse",
							"adres": "Lange Strasse 75\n26122 Oldenburg\nGermany"
						}
					]
				},
				{
					"name": "Potsdam",
					"slug": "potsdam",
					"stores": [
						{
							"name": "Vero Moda babelsberger strasse",
							"adres": "Babelsberger Str. 16\n14473 Potsdam\nGermany"
						}
					]
				},
				{
					"name": "Rheine",
					"slug": "rheine",
					"stores": [
						{
							"name": "Vero Moda emsstrasse ",
							"adres": "Emsstr. 35\n48431 Rheine\nGermany"
						}
					]
				}
			]
		},
		{
			"name": "Iceland",
			"slug": "iceland",
			"cities": [
				{
					"name": "Kopavogur",
					"slug": "kopavogur",
					"stores": [
						{
							"name": "smaralind shopping center ",
							"adres": "Hagasmára 1\n201 Kópavogur\nIceland"
						}
					]
				}
			]
		},
		{
			"name": "Italy",
			"slug": "italy",
			"cities": [
				{
					"name": "Oderzo",
					"slug": "oderzo",
					"stores": [
						{
							"name": "ami (buso vania)  ",
							"adres": "Via del Bersagliere 2\n31046 Oderzo\nItaly"
						}
					]
				},
				{
					"name": "Ponte san giovanni",
					"slug": "ponte-san-giovanni",
					"stores": [
						{
							"name": "coni sport",
							"adres": "Piazza Annibale Valigi 15\n06135 Ponte San Giovanni\nItaly"
						}
					]
				},
				{
					"name": "Mandolfo",
					"slug": "mandolfo",
					"stores": [
						{
							"name": "officina 36 (magazzino) ",
							"adres": "V. Volta 38\n61037 Mondolfo\nItaly"
						}
					]
				},
				{
					"name": "Vittoria",
					"slug": "vittoria",
					"stores": [
						{
							"name": "the street ",
							"adres": "Via Cavour 260\n97019 Vittoria\nItaly"
						}
					]
				},
				{
					"name": "Maida",
					"slug": "maida",
					"stores": [
						{
							"name": "zebra",
							"adres": "Loc. Comuni Condomini\n88025 Maida\nItaly"
						}
					]
				}
			]
		},
		{
			"name": "Jordan",
			"slug": "jordan",
			"cities": [
				{
					"name": "Amman",
					"slug": "amman",
					"stores": [
						{
							"name": "Vero Moda mecca mall ",
							"adres": "Mecca street - Mecca Mall\nAmman\nJordan"
						},
						{
							"name": "Vero Moda city mall",
							"adres": "City Mall\nAmman\nJordan"
						}
					]
				}
			]
		},
		{
			"name": "Kuwait",
			"slug": "kuwait",
			"cities": [
				{
					"name": "Al rai",
					"slug": "al-rai",
					"stores": [
						{
							"name": "the avenue mall",
							"adres": "The Avenue Mall\n5th Ring Road\nAl Rai 29927\nKuwait"
						}
					]
				}
			]
		},
		{
			"name": "Lebanon",
			"slug": "lebanon",
			"cities": [
				{
					"name": "Lebanon",
					"slug": "lebanon",
					"stores": [
						{
							"name": "abc mall ",
							"adres": "ABC Mall, Dbaye 11-4494\nDbaye\nLebanon"
						}
					]
				},
				{
					"name": "Beirut",
					"slug": "beirut",
					"stores": [
						{
							"name": "beirut city center ",
							"adres": "Baabda, Hazmieh street\nPlot 1090\n114494 Beirut\nLebanon"
						},
						{
							"name": "Vero Moda aley  ",
							"adres": "Al Maarad Street\n1st floor building 286\n114494 Beirut\nLebanon"
						},
						{
							"name": "Vero Moda city mall ",
							"adres": "Al Maarad Street\n1st Floor building 286\n114494 Beirut\nLebanon"
						},
						{
							"name": "Vero Moda zalka ",
							"adres": "Al Maarad Street\n1st floor building 286\n114494 Beirut\nLebanon"
						},
						{
							"name": "Vero Moda le mall ",
							"adres": "Le Mall\nCin El Feel\nBeirut 114494\nLebanon"
						},
						{
							"name": "Vero Moda souk beirut ",
							"adres": "Moutraniye Street\nBeirut 114494\nLebanon"
						},
						{
							"name": "Vero Moda takla 773",
							"adres": "Hamra\nBeirut 114494\nLebanon"
						},
						{
							"name": "Vero Moda zahle ",
							"adres": "Zahle Main Street\nBeirut 114494\nLebanon"
						}
					]
				},
				{
					"name": "Nabatieh",
					"slug": "nabatieh",
					"stores": [
						{
							"name": "jack & jones nabatieh mall ",
							"adres": "Nabatieh main road, kfarjoz\nNabatieh Mall\nNabatieh\nLebanon"
						}
					]
				},
				{
					"name": "Saida",
					"slug": "saida",
					"stores": [
						{
							"name": "saida mall ",
							"adres": "Saida Mall - Plot 1820 Wasstani\nSaida\nLebanon"
						}
					]
				},
				{
					"name": "Tripoli",
					"slug": "tripoli",
					"stores": [
						{
							"name": "Vero Moda tripoli mall ",
							"adres": "Karameh Bldg.\nTripoli\nLebanon"
						}
					]
				}
			]
		},
		{
			"name": "Lithuania",
			"slug": "lithuania",
			"cities": [
				{
					"name": "Vilnius",
					"slug": "vilnius",
					"stores": [
						{
							"name": "new mood ",
							"adres": "Kubiliaus g. 21\nLT-09108 Vilnius\nLithuania"
						}
					]
				},
				{
					"name": "Kaunas",
					"slug": "kaunas",
					"stores": [
						{
							"name": "Vero Moda pc mega ",
							"adres": "PC Megalslandijos Pl.32\n49177 Kaunas\nLithuania"
						}
					]
				}
			]
		},
		{
			"name": "Netherlands",
			"slug": "netherlands",
			"cities": [
				{
					"name": "Online",
					"slug": "online",
					"stores": [
						{
							"name": "wehkamp",
							"adres": "<a target=\"_blank\" href=\"https://www.wehkamp.nl/damesmode/noisy-may/noisy-may/C21_AAE_AAE/\">Shop online</a>"
						},
						{
							"name": "Things I like Things I love",
							"adres": "<a target=\"_blank\" href=\"http://webshop.thingsilikethingsilove.com\">Shop online</a>"
						},
						{
							"name": "Freewear C.V",
							"adres": "<a target=\"_blank\" href=\"https://www.freewear.nl/noisy-may/\">Shop online</a>"
						}
					]
				},
				{
					"name": "Barneveld",
					"slug": "barneveld",
					"stores": [
						{
							"name": "b1 fashion",
							"adres": "Langstraat 85A\n3771 BC Barneveld\nNetherlands"
						}
					]
				},
				{
					"name": "Alkmaar",
					"slug": "alkmaar",
					"stores": [
						{
							"name": "black & blue  ",
							"adres": "Laat 175\n1811 EE Alkmaar\nNetherlands"
						}
					]
				},
				{
					"name": "Heemskerk",
					"slug": "heemskerk",
					"stores": [
						{
							"name": "brantjes mode bv ",
							"adres": "Kerkweg 28\n1961 JD Heemskerk\nNetherlands"
						}
					]
				},
				{
					"name": "Amsterdam",
					"slug": "amsterdam",
					"stores": [
						{
							"name": "Bestseller handels bv",
							"adres": "Vijzelstraat 68-78\n1017 HL Amsterdam\nNetherlands"
						},
						{
							"name": "OBJECT collectors item kinkerstraat ",
							"adres": "Kinkerstraat 161\n1053 DN Amsterdam\nNetherlands"
						},
						{
							"name": "reward",
							"adres": "1e van Swindenstraat 191\n1093 GB Amsterdam\nNetherlands"
						},
						{
							"name": "Things I like things I love ",
							"adres": "Ceintuurbaan 69\n1072 EV Amsterdam\nNetherlands"
						},
						{
							"name": "Things I like things I love ",
							"adres": "Jan Evertsenstraat 106\n1056 EH Amsterdam\nNetherlands"
						},
						{
							"name": "Things I like things I love ",
							"adres": "Gasthuismolensteeg 10\n1016 AN Amsterdam\nNetherlands"
						}
					]
				},
				{
					"name": "Spakenburg",
					"slug": "spakenburg",
					"stores": [
						{
							"name": "freewear cv 1150 ",
							"adres": "Zuidwenk 100\n3751 CG Spakenburg\nNetherlands"
						}
					]
				},
				{
					"name": "Leeuwarden",
					"slug": "leeuwarden",
					"stores": [
						{
							"name": "in fession",
							"adres": "Kleine Kerkstraat 37\n8911 DL Leeuwarden\nNetherlands"
						},
						{
							"name": "Vero Moda nieuwestad",
							"adres": "Nieuwestad 132\n8911 DA Leeuwarden\nNetherlands"
						}
					]
				},
				{
					"name": "Urk",
					"slug": "urk",
					"stores": [
						{
							"name": "jeksiz",
							"adres": "Wijk 2-5\n8321 EP Urk\nNetherlands"
						}
					]
				},
				{
					"name": "Doetinchem",
					"slug": "doetinchem",
					"stores": [
						{
							"name": "lynn",
							"adres": "Heezenstraat 19A\n7001 BP Doetinchem\nNetherlands"
						}
					]
				},
				{
					"name": "De Koog",
					"slug": "dekoog",
					"stores": [
						{
							"name": "BY LIEN",
							"adres": "Dorpsstraat 143\n1796 CB De Koog\nTexel, Netherlands"
						}
					]
				},
				{
					"name": "Rotterdam",
					"slug": "rotterdam",
					"stores": [
						{
							"name": "most wanted",
							"adres": "Oppert 290\n3011 HV Rotterdam\nNetherlands"
						},
						{
							"name": "Vero Moda hoogstraat ",
							"adres": "Hoogstraat 188-190\n3011 PV Rotterdam\nNetherlands"
						}
					]
				},
				{
					"name": "Den helder",
					"slug": "den-helder",
					"stores": [
						{
							"name": "nameless",
							"adres": "Keizerstraat 25\n1781 GD Den Helder\nNetherlands"
						}
					]
				},
				{
					"name": "Hoorn",
					"slug": "hoorn",
					"stores": [
						{
							"name": "OBJECT collectors item ",
							"adres": "Grote Noord 61\n1621 KE Hoorn\nNetherlands"
						}
					]
				},
				{
					"name": "Zaandam",
					"slug": "zaandam",
					"stores": [
						{
							"name": "OBJECT collectors item ",
							"adres": "Gedempte Gracht 75\n1506 CC Zaandam\nNetherlands"
						}
					]
				},
				{
					"name": "Zeist",
					"slug": "zeist",
					"stores": [
						{
							"name": "OBJECT collectors item",
							"adres": "Slotlaan 170\n3701 GS Zeist\nNetherlands"
						}
					]
				},
				{
					"name": "Wieringerwerf",
					"slug": "wieringerwerf",
					"stores": [
						{
							"name": "qjoezz factory ",
							"adres": "Terpstraat 11\n1771 AC Wieringerwerf\nNetherlands"
						}
					]
				},
				{
					"name": "Rijssen",
					"slug": "rijssen",
					"stores": [
						{
							"name": "tonik bv",
							"adres": "Haarstraat 35\n7462 AK Rijssen\nNetherlands"
						}
					]
				},
				{
					"name": "Den bosch",
					"slug": "den-bosch",
					"stores": [
						{
							"name": "Vero Moda arena ",
							"adres": "Arena 162\n5211 XT Den Bosch\nNetherlands"
						}
					]
				},
				{
					"name": "Emmen",
					"slug": "emmen",
					"stores": [
						{
							"name": "Vero Moda picassopassage",
							"adres": "Picassopassage 29\n7811 DN Emmen\nNetherlands"
						}
					]
				},
				{
					"name": "Groningen",
					"slug": "groningen",
					"stores": [
						{
							"name": "Vero Moda herestraat ",
							"adres": "Herestraat 25\n9711 LA Groningen\nNetherlands"
						}
					]
				}
			]
		},
		{
			"name": "Norway",
			"slug": "norway",
			"cities": [
				{
					"name": "Skjervoy",
					"slug": "skjervoy",
					"stores": [
						{
							"name": "aina as",
							"adres": "Strandveien 66\n9180 Skjervøy\nNorway"
						}
					]
				},
				{
					"name": "Ulsteinvik",
					"slug": "ulsteinvik",
					"stores": [
						{
							"name": "best fashion",
							"adres": "Vike Myra 1\n6065 Ulsteinvik\nNorway"
						}
					]
				},
				{
					"name": "Ottersay",
					"slug": "ottersay",
					"stores": [
						{
							"name": "purefab as ",
							"adres": "Lørdagsvika\n7940 Ottersøy\nNorway"
						}
					]
				},
				{
					"name": "Verdel",
					"slug": "verdel",
					"stores": [
						{
							"name": "purefab verdal ",
							"adres": "Jernbanegata 11\n7650 Verdel\nNorway"
						}
					]
				},
				{
					"name": "Andenes",
					"slug": "andenes",
					"stores": [
						{
							"name": "skredderloftet as ",
							"adres": "Tore Hundsgate 3\n8480 Andenes\nNorway"
						}
					]
				},
				{
					"name": "Hitra",
					"slug": "hitra",
					"stores": [
						{
							"name": "twins as",
							"adres": "Hitratorget\n7240 Hitra\nNorway"
						}
					]
				}
			]
		},
		{
			"name": "Poland",
			"slug": "poland",
			"cities": [
				{
					"name": "Online",
					"slug": "online",
					"stores": [
						{
							"name": "Answear.com",
							"adres": "<a target=\"_blank\" href=\"http://answear.com/p/wyszukiwanie/q-noisy%20may/k-4/\">Shop online</a>"
						}
					]
				},
				{
					"name": "Skawina",
					"slug": "skawina",
					"stores": [
						{
							"name": "answear magazyn",
							"adres": "Ul Halacinskiego 2\nPanattoni Park Skawina\n32-050 Skawina\nPoland"
						}
					]
				}
			]
		},
		{
			"name": "Saudi arabia",
			"slug": "saudi-arabia",
			"cities": [
				{
					"name": "Jeddah",
					"slug": "jeddah",
					"stores": [
						{
							"name": "Vero Moda andalus mall ",
							"adres": "Prince Majid Street\nJeddah\nSaudi Arabia"
						},
						{
							"name": "Vero Moda aziz mall",
							"adres": "Prince Majed Street\nAl Faysaleeyah\nJeddah 21352\nSaudi Arabia"
						},
						{
							"name": "Vero Moda salam mall",
							"adres": "Prince Majed Road\nJeddah\nSaudi Arabia"
						}
					]
				},
				{
					"name": "Dhahran",
					"slug": "dhahran",
					"stores": [
						{
							"name": "Vero Moda dharan mall ",
							"adres": "Dhahran street"
						}
					]
				},
				{
					"name": "Riyadh",
					"slug": "riyadh",
					"stores": [
						{
							"name": "Vero Moda khurais mall ",
							"adres": "Khurais road\nRiyadh 11333\nSaudi Arabia"
						},
						{
							"name": "Vero Moda nakheel mall ",
							"adres": "Al imam saud bin abdul aziz\nRiyadh\nSaudi Arabia"
						},
						{
							"name": "Vero Moda salam plaza ",
							"adres": "Western ring road\nRiyadh 11333\nSaudi Arabia"
						}
					]
				}
			]
		},
		{
			"name": "South africa",
			"slug": "south-africa",
			"cities": [
				{
					"name": "Johannesburg",
					"slug": "johannesburg",
					"stores": [
						{
							"name": "superbalist.com ",
							"adres": "No. 50 Maple Road\n1620 Gauteng\nSouth Africa"
						}
					]
				}
			]
		},
		{
			"name": "Spain",
			"slug": "spain",
			"cities": [
				{
					"name": "Teruel",
					"slug": "teruel",
					"stores": [
						{
							"name": "ferran 1820",
							"adres": "Nuevo, 2-4 Ferran\n44001 Teruel\nSpain"
						}
					]
				},
				{
					"name": "Cieza",
					"slug": "cieza",
					"stores": [
						{
							"name": "manuela marin cano ",
							"adres": "Buen suceso, 17 Bajo\n30530 Cieza\nSpain"
						}
					]
				},
				{
					"name": "Badalona",
					"slug": "badalona",
					"stores": [
						{
							"name": "olisse ",
							"adres": "Avda. Marti Pujol, 104-106 Bajos\n08911 Badalona\nSpain"
						}
					]
				},
				{
					"name": "Barcelona",
					"slug": "barcelona",
					"stores": [
						{
							"name": "vanities",
							"adres": "Espronceda 331\n08027 Barcelona\nSpain"
						}
					]
				}
			]
		},
		{
			"name": "Sweden",
			"slug": "sweden",
			"cities": [
				{
					"name": "Tomelilla",
					"slug": "tomelilla",
					"stores": [
						{
							"name": "bo ohlsson ",
							"adres": "Malmövägen 12\n273 35 Tomelilla\nSweden"
						}
					]
				},
				{
					"name": "Falkenberg",
					"slug": "falkenberg",
					"stores": [
						{
							"name": "nelly.com ",
							"adres": "Västerhavsvägen 2\nPort 1-4\n311 42 Falkenberg\nSweden"
						}
					]
				}
			]
		},
		{
			"name": "Switzerland",
			"slug": "switzerland",
			"cities": [
				{
					"name": "Aarau",
					"slug": "aarau",
					"stores": [
						{
							"name": "Vero Moda hintere vorstadt ",
							"adres": "Hintere Vorstadt 14\n5000 Aarau Switzerland"
						}
					]
				},
				{
					"name": "Basel",
					"slug": "basel",
					"stores": [
						{
							"name": "Vero Moda st jakob park",
							"adres": "St. Jacobs-Strasse 395\n4052 Basel\nSwitzerland"
						},
						{
							"name": "Vero Moda/jack&jones mega store ",
							"adres": "Steinenvorstadt 5\n4051 Basel\nSwitzerland"
						}
					]
				},
				{
					"name": "Bern",
					"slug": "bern",
					"stores": [
						{
							"name": "Vero Moda bern westside ",
							"adres": "Riedbachstrasse 100\n3027 Bern\nSwitzerland"
						},
						{
							"name": "Vero Moda/jack&jones christoffel ",
							"adres": "Neuer Bahnhof Bern\n3011 Bern\nSwitzerland"
						},
						{
							"name": "Vero Moda/jack&jones marktgasse 31",
							"adres": "Marktgasse 31\n3011 Bern\nSwitzerland"
						}
					]
				},
				{
					"name": "Biel",
					"slug": "biel",
					"stores": [
						{
							"name": "Vero Moda bahnhofstrasse ",
							"adres": "Bahnhofstrasse 39\n2503 Biel\nSwitzerland"
						}
					]
				},
				{
					"name": "Brig-glis",
					"slug": "brig-glis",
					"stores": [
						{
							"name": "Vero Moda ",
							"adres": "Kantonsstrasse 58\n3902 Glis\nSwitzerland"
						}
					]
				},
				{
					"name": "Chur",
					"slug": "chur",
					"stores": [
						{
							"name": "Vero Moda poststrasse ",
							"adres": "Poststrasse 24\n7000 Chur\nSwitzerland"
						}
					]
				},
				{
					"name": "Chateauneuf",
					"slug": "chateauneuf",
					"stores": [
						{
							"name": "conthey forum des alpes ",
							"adres": "Route Des Rottes 15\n1964 Châteauneuf\nSwitzerland"
						}
					]
				},
				{
					"name": "Geneve",
					"slug": "geneve",
					"stores": [
						{
							"name": "Vero Moda rue de rive ",
							"adres": "Rue de Rive 15\n1204 Geneve\nSwitzerland"
						},
						{
							"name": "Vero Moda/jack&jones rue du marche",
							"adres": "Rue du Marche 8\n1204 Geneve\nSwitzerland"
						}
					]
				},
				{
					"name": "Kreuzlingen",
					"slug": "kreuzlingen",
					"stores": [
						{
							"name": "Vero Moda hauptstrasse ",
							"adres": "Hauptstrasse 51\n8280 Kreuzlingen\nSwitzerland"
						}
					]
				},
				{
					"name": "La chaux de fonds",
					"slug": "la-chaux-de-fonds",
					"stores": [
						{
							"name": "Vero Moda avenue leopold robert",
							"adres": "Avenue Léopold Robert 52\n2300 La Chaux-de-Fonds\nSwitzerland"
						}
					]
				},
				{
					"name": "Lausanne",
					"slug": "lausanne",
					"stores": [
						{
							"name": "Vero Moda rue haldimand ",
							"adres": "Rue Haldimand 12\n1003 Lausanne\nSwitzerland"
						},
						{
							"name": "Vero Moda metropole ",
							"adres": "Rue des Terraux 17\n1008 Lausanne\nSwitzerland"
						}
					]
				},
				{
					"name": "Neuchatel",
					"slug": "neuchatel",
					"stores": [
						{
							"name": "Vero Moda la maladiere",
							"adres": "Pierre-a-Mazel 10\n2000 Neuchatel\nSwitzerland"
						}
					]
				},
				{
					"name": "Nyon",
					"slug": "nyon",
					"stores": [
						{
							"name": "Vero Moda rue de la morache ",
							"adres": "Rue de la Morâche 6\n1260 Nyon\nSwitzerland"
						}
					]
				},
				{
					"name": "Olten",
					"slug": "olten",
					"stores": [
						{
							"name": "Vero Moda baslerstrasse ",
							"adres": "Baslerstrasse 32\n4600 Olten\nSwitzerland"
						}
					]
				},
				{
					"name": "Kriens",
					"slug": "kriens",
					"stores": [
						{
							"name": "Vero Moda pilatusmarkt - kriens ",
							"adres": "Ringstrasse 19\n6010 Kriens\nSwitzerland"
						}
					]
				},
				{
					"name": "Rapperswil - jona",
					"slug": "rapperswil---jona",
					"stores": [
						{
							"name": "Vero Moda sonnenhof ",
							"adres": "Zücherstr. 4\n8640 Rapperswil-Jona\nSwitzerland"
						}
					]
				},
				{
					"name": "Schaffhausen",
					"slug": "schaffhausen",
					"stores": [
						{
							"name": "Vero Moda fronwaldplatz",
							"adres": "Fronwagplatz 14\n8200 Schaffhausen\nSwitzerland"
						}
					]
				},
				{
					"name": "Sion",
					"slug": "sion",
					"stores": [
						{
							"name": "Vero Moda avenue du midi ",
							"adres": "Avenue du Midi 14\n1950 Sion\nSwitzerland"
						}
					]
				},
				{
					"name": "Solothurn",
					"slug": "solothurn",
					"stores": [
						{
							"name": "Vero Moda hauptgasse ",
							"adres": "Hauptgasse 30\n4500 Solothurn\nSwitzerland"
						}
					]
				},
				{
					"name": "St gallen",
					"slug": "st-gallen",
					"stores": [
						{
							"name": "Vero Moda marktgasse ",
							"adres": "Marktgasse 13\n9000 St Gallen\nSwitzerland"
						}
					]
				},
				{
					"name": "St gallen-winkeln",
					"slug": "st-gallen-winkeln",
					"stores": [
						{
							"name": "Vero Moda shopping arena ",
							"adres": "Zürcher Str. 464\nShopping Arena St. Gallen\n9015 St. Gallen-Winkeln\nSwitzerland"
						}
					]
				},
				{
					"name": "Thun",
					"slug": "thun",
					"stores": [
						{
							"name": "Vero Moda balliz ",
							"adres": "Bälliz 69 A\n3600 Thun\nSwitzerland"
						}
					]
				},
				{
					"name": "Yverdon-les-bains",
					"slug": "yverdon-les-bains",
					"stores": [
						{
							"name": "rue du lac",
							"adres": "Rue du Lac 34\n1400 Yverdon-les-Bains\nSwitzerland"
						}
					]
				},
				{
					"name": "Luzern",
					"slug": "luzern",
					"stores": [
						{
							"name": "Vero Moda/jack&jones hertensteinstrasse ",
							"adres": "Hertensteinstrasse 34\n6004 Luzern\nSwitzerland"
						}
					]
				},
				{
					"name": "Spreitenbach",
					"slug": "spreitenbach",
					"stores": [
						{
							"name": "Vero Moda/jack&jones shoppi tivoli ",
							"adres": "Hoch Haus 9\n8957 Spreitenbach\nSwitzerland"
						}
					]
				}
			]
		},
		{
			"name": "Turkey",
			"slug": "turkey",
			"cities": [
				{
					"name": "Adapazari",
					"slug": "adapazari",
					"stores": [
						{
							"name": "moz jeans magazacilik ",
							"adres": "Cark Cad. No:14\n54100 Adapazari\nTurkey"
						}
					]
				}
			]
		},
		{
			"name": "United arab emirates",
			"slug": "united-arab-emirates",
			"cities": [
				{
					"name": "Online",
					"slug": "online",
					"stores": [
						{
							"name": "Namshi General Trading",
							"adres": "<a target=\"_blank\" href=\"https://en-ae.namshi.com/noisy_may/\">Shop online</a>"
						}
					]
				},
				{
					"name": "Dubai",
					"slug": "dubai",
					"stores": [
						{
							"name": "Vero Moda dubai mall ",
							"adres": "Financial Centre Road, Downtown Dubai\nDubai\nUnited Arab Emirates"
						},
						{
							"name": "Vero Moda mall of emirates",
							"adres": "Sheikh Zayed Road\nDubai\nUnited Arab Emirates"
						},
						{
							"name": "Vero Moda/jack&jones mirdif city centre ",
							"adres": "Emirates Road\nDubai\nUnited Arab Emirates"
						},
						{
							"name": "namshi general trading llc",
							"adres": "Galadari Ready Mix Building\nPlot 599-737\nDubai\nUnited Arab Emirates"
						},
						{
							"name": "sivvi.com ",
							"adres": "Street 8, Al Quoz Industrial 3\nWarehouse 11\nDubai\nUnited Arab Emirates"
						}
					]
				},
				{
					"name": "Sharjah",
					"slug": "sharjah",
					"stores": [
						{
							"name": "Vero Moda sahara mall ",
							"adres": "Sharjah Highway\nPObox: 510051\nSharjah\nUnited Arab Emirates"
						}
					]
				},
				{
					"name": "Abu dhabi",
					"slug": "abu-dhabi",
					"stores": [
						{
							"name": "Vero Moda yas mall ",
							"adres": "Yas Mall Abu Dhabi\nAbu Dhabi\nUnited Arab Emirates"
						}
					]
				}
			]
		},
		{
			"name": "United kingdom",
			"slug": "united-kingdom",
			"cities": [
				{
					"name": "Online",
					"slug": "online",
					"stores": [
						{
							"name": "Asos.com",
							"adres": "<a target=\"_blank\" href=\"http://us.asos.com/search/noisy-may?q=noisy+may&RecentSearchesUsed=true\">Shop online</a>"
						},
						{
							"name": "Glebe Fashion",
							"adres": "<a target=\"_blank\" href=\"http://www.glebe-fashion.com/noisy-may-m131\">Shop online</a>"
						},
						{
							"name": "Meg Maitland",
							"adres": "<a target=\"_blank\" href=\"http://www.megmaitland.com/about/\">Shop online</a>"
						},
						{
							"name": "Newlook Retailers",
							"adres": "<a target=\"_blank\" href=\"http://www.newlook.com/shop/womens/_/Ncm2?Ntt=noisy+may&icCategory=cat10002&filtered=1\">Shop online</a>"
						},
						{
							"name": "Thunder Egg limited",
							"adres": "<a target=\"_blank\" href=\"https://thunderegg.co.uk/product-category/brands/noisy-may/\">Shop online</a>"
						}
					]
				},
				{
					"name": "Bradford",
					"slug": "bradford",
					"stores": [
						{
							"name": "asos.com ltd ",
							"adres": "Building 606, Wharfedale Road\nBD4 6SG Bradford\nUnited Kingdom"
						}
					]
				},
				{
					"name": "Craigavon",
					"slug": "craigavon",
					"stores": [
						{
							"name": "dv8 fashion ",
							"adres": "Unit 2 M12 Business Park, Charlestown New Road, Portadown"
						}
					]
				},
				{
					"name": "North berwick",
					"slug": "north-berwick",
					"stores": [
						{
							"name": "meg maitland ",
							"adres": "76 High Street\nEH39 4LW North Berwick\nUnited Kingdom"
						}
					]
				},
				{
					"name": "Waltham cross",
					"slug": "waltham-cross",
					"stores": [
						{
							"name": "nels belles boutique ltd",
							"adres": "58 High Street\nEN8 0AQ Waltham Cross\nUnited Kingdom"
						}
					]
				},
				{
					"name": "Halifax",
					"slug": "halifax",
					"stores": [
						{
							"name": "newlook retailers ltd ",
							"adres": "Sidhil Business Park\nHX2 9TN Halifax\nUnited Kingdom"
						}
					]
				},
				{
					"name": "Royston",
					"slug": "royston",
					"stores": [
						{
							"name": "rhona colquhoun du",
							"adres": "Cokenach Estate, Barkway\nSG8 8DL Royston\nUnited Kingdom"
						}
					]
				},
				{
					"name": "Liverpool",
					"slug": "liverpool",
					"stores": [
						{
							"name": "shop direct home shopping ltd",
							"adres": "1st Floor Skyways House, Speke Road"
						}
					]
				}
			]
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./data/stockists.json
// module id = 80
// module chunks = 0